/** Web dashboard / manager login URL (separate from this marketing site). */
export default function getDashboardUrl(): string {
  return process.env.REACT_APP_DASHBOARD_URL || 'https://manager.gastrobuddy.nl';
}



// WEBPACK FOOTER //
// ./src/constants/dashboard.ts